import { render, staticRenderFns } from "./mamSubFollowSetting.vue?vue&type=template&id=6eb75cd2&scoped=true"
import script from "./mamSubFollowSetting.vue?vue&type=script&lang=js"
export * from "./mamSubFollowSetting.vue?vue&type=script&lang=js"
import style0 from "./mamSubFollowSetting.vue?vue&type=style&index=0&id=6eb75cd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb75cd2",
  null
  
)

export default component.exports